
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".site-header");
  if (!header) return;

  // Check if we are on the homepage
  const onHome = (window.location.pathname === "/" || window.location.pathname === "/index");

  if (!onHome) {
    // Not home → do nothing (maroon is default)
    return;
  }

  function updateNavColor() {
    const passed = window.scrollY > window.innerHeight;
    header.classList.toggle("hero-white", !passed);
  }

  window.addEventListener("scroll", updateNavColor);
  updateNavColor();
});


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".site-header");
  if (!header) return;

  const merlotLogo = "https://cdn.shopify.com/s/files/1/0703/5997/4080/files/MO-logo-merlot.svg?v=1763489210";
  const creamLogo  = "https://cdn.shopify.com/s/files/1/0703/5997/4080/files/MO-logo-cream.svg?v=1763489209";

  // Create link wrapper for logo
  const logoLink = document.createElement("a");
  logoLink.href = "/";
  logoLink.className = "mo-logo-link";
  logoLink.setAttribute("aria-label", "Mostly Objects home");

  // Create logo image
  const logo = document.createElement("img");
  logo.className = "mo-logo";
  logo.alt = "Mostly Objects";
  logo.style.height = "25px";
  logo.style.width = "auto";
  logo.style.display = "block";

  logoLink.appendChild(logo);
  header.prepend(logoLink);

  // Homepage detection
  const onHome = window.location.pathname === "/" || window.location.pathname === "/index";

  function updateLogo() {
    if (!onHome) {
      // Non-home pages → always merlot
      logo.src = merlotLogo;
      return;
    }

    const passed = window.scrollY > window.innerHeight;
    logo.src = passed ? merlotLogo : creamLogo;
  }

  window.addEventListener("scroll", updateLogo);
  updateLogo(); // run once on load
});

